import { useState } from "react";
import { Button, Alert, CloseButton, Col } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { useCmsHook } from "./cmsHook";
import { cmsConstructor } from "./cmsConstructor";
import { useDispatch } from "react-redux";

const CmsEditBanner = () => {
  const [closeBtn, setCloseBtn] = useState(false);
  const [showSaveBtn, setShowSaveBtn] = useState(false);
  const {
    cmsInstance,
    isEdit,
    allowedUsers,
    setIsAllowedUser,
    isAllowedUser,
    setIsEdit,
    setCmsInstance,
  } = useCmsHook();

  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const accountId = searchParams.get("account");
  // const tenantId = searchParams.get("tenantId");

  let isUserAllowed = false;
  for (const account of allowedUsers) {
    if (account.account === accountId) {
      isUserAllowed = true;
      break;
    }
  }

  if (isUserAllowed !== isAllowedUser && closeBtn === false) {
    setIsAllowedUser(isUserAllowed);
  }

  const handleEdit = () => {
    setIsEdit(true);
    setShowSaveBtn(true);
  };

  const handleClose = () => {
    setIsAllowedUser(false);
    setCloseBtn(true);
    setIsEdit(false);
  };

  const handlePreview = () => {
    setIsEdit(false);
  };

  const handleSaveChanges = () => {
    cmsInstance.saveContentChanges();
    setIsEdit(false);
    setShowSaveBtn(false);
  };

  const handleCancel = async () => {
    setIsEdit(false);
    setShowSaveBtn(false);
    const pmCmsInstance = await cmsConstructor(dispatch);
    setCmsInstance(pmCmsInstance);
  };

  return (
    <>
      {isAllowedUser && (
        <Col lg={8}>
          <Alert
            className={`alert-modal d-flex flex-row justify-content-between align-items-center m-0 ${
              window.location.pathname === "/setup" && "mt-3"
            }`}
          >
            <div>
              <p className="text-center mt-2">
                To change the content click on the edit button below.
              </p>
            </div>
            <div className="d-flex flex-row justify-content-end align-items-center h-100 my-auto">
              {window.location.pathname !== "/edit-notifications" && (
                <Button
                  variant="link"
                  href={`/edit-notifications?account=${accountId}`}
                  target="_blank"
                  className="me-2"
                >
                  Edit notifications
                </Button>
              )}
              {showSaveBtn && (
                <Button
                  className="save-content-changes-btn"
                  onClick={() => handleSaveChanges()}
                >
                  Save
                </Button>
              )}
              {!isEdit && (
                <Button
                  className="save-content-changes-btn ms-2"
                  onClick={() => handleEdit()}
                >
                  Edit
                </Button>
              )}

              {isEdit && (
                <Button
                  onClick={() => handlePreview()}
                  className="preview-btn ms-2"
                >
                  Preview
                </Button>
              )}
              {isEdit && (
                <Button
                  className="delete-modal-delete-btn ms-2"
                  onClick={() => handleCancel()}
                >
                  Cancel
                </Button>
              )}
              <div className="ms-2">
                <CloseButton onClick={handleClose} />
              </div>
            </div>
          </Alert>
        </Col>
      )}
    </>
  );
};

export default CmsEditBanner;
